import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { TokenId } from "@martiandao/aptos-web3-bip44.js";
import { useState, useEffect } from "react";

import DownArrow from "../../../imgs/down-arrow.svg";
import UpArrow from "../../../imgs/up-arrow.svg";
import { getFoilNFTs, getVestValue } from "../../../libs/vesting_escrow";
import { getTokenId } from "../../../utils/common";

export interface VeNftInfo {
  token_id: number;
  vest_value: string;
}
type Props = {
  setTokenId: Function;
};
const SelectNftBox: React.FC<Props> = ({ setTokenId }) => {
  const [openList, setOpenList] = useState<boolean>(false);
  const [selectedToken, setSelectedToken] = useState<string>("");
  const [nftList, setNftList] = useState<VeNftInfo[]>([]);
  const { account } = useWallet();
  useEffect(() => {
    const fetch = async () => {
      if (!account) return;
      const res: TokenId[] = await getFoilNFTs(account.address as string);
      const res_nfts_info: VeNftInfo[] = [];
      for (let i = 0; i < res.length; i++) {
        const token_id: TokenId = res[i];
        const token_id_num = getTokenId(token_id.token_data_id.name);
        const vest_value = await getVestValue(token_id_num);
        res_nfts_info.push({
          token_id: token_id_num,
          vest_value: (vest_value / 1000000000).toFixed(2),
        });
        if (i === 0) {
          setSelectedToken(
            `Token #${token_id_num}  veNFT: ${(vest_value / 1000000000).toFixed(
              2
            )}`
          );
          setTokenId(token_id_num);
        }
      }

      setNftList(res_nfts_info);
    };
    if (account) {
      fetch();
    }
  }, [account]);

  return (
    <div className="flex w-full bg-primary-200 rounded-lg items-center px-5 py-3 gap-4">
      <p className="w-fit text-white text-opacity-50 shrink-0">
        Select Your Token:
      </p>
      <div
        className="w-full h-full flex justify-between relative cursor-pointer"
        onClick={() => setOpenList((value) => !value)}
      >
        <p className="text-white">{selectedToken}</p>
        <img src={openList ? UpArrow : DownArrow} className="h-full" />
        {openList && (
          <div className="absolute right-0 top-10 bg-primary-200 w-full p-4 rounded-lg z-10">
            {nftList.map((item, index) => (
              <p
                className="text-white px-3 py-2 text-opacity-50 hover:text-opacity-100 hover:bg-white hover:bg-opacity-5 rounded-md"
                key={`TokenList-${index}`}
                onClick={() => {
                  setSelectedToken(
                    `Token #${item.token_id}  veNFT: ${item.vest_value}`
                  );
                  setTokenId(item.token_id);
                }}
              >
                {`Token #${item.token_id} veNft: ${item.vest_value}`}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectNftBox;
